import { render, staticRenderFns } from "./ErrorPayment.vue?vue&type=template&id=0ada56d2&scoped=true"
import script from "./ErrorPayment.vue?vue&type=script&lang=js"
export * from "./ErrorPayment.vue?vue&type=script&lang=js"
import style0 from "./ErrorPayment.vue?vue&type=style&index=0&id=0ada56d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada56d2",
  null
  
)

export default component.exports